import api from '@pray/shared/utils/api';

type DeleteSlotAssignmentParams = {
  assignmentId: string;
  fromDate?: string;
};

export async function deletePrayTvSlotAssignment({ assignmentId, fromDate }: DeleteSlotAssignmentParams) {
  if (!assignmentId) throw Error('Assignment ID is required');

  const query = fromDate ? `?from_date=${encodeURIComponent(fromDate)}` : '';
  const url = `/web/studio/pray-tv/slot-assignments/${assignmentId}${query}`;
  const response = await api.executeDeleteRequest(url);

  return response.data;
}
